import { Component, OnInit, Input, OnChanges, SimpleChanges, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { Supervision, SupervisionStatusEnum } from 'solar-bo';
import { SolarBase1Component } from '@solar/solar/solar-base';
import { SolarService } from '../../services/solarservice.service';

@Component({
  selector: 'app-supervstatus-dlg',
  templateUrl: './supervstatus.component.html',
  styleUrls: ['./supervstatus.component.scss']
})
export class SupervStatusComponent extends SolarBase1Component implements OnInit, AfterViewInit {

  //for html 
  supervisionStatusEnum:SupervisionStatusEnum;
  @Input() supervision: Supervision;
  @Output() statusChange: EventEmitter<any> = new EventEmitter();
  statusselected: any;
  submitted: boolean = false;
  statuslist: any[] = [{ id: SupervisionStatusEnum.TOVALIDATE, name: "to Validate" }, { id: SupervisionStatusEnum.VALIDATED, name: "Validated" }];

  constructor(
    public solarService: SolarService) {
    super();
  }

  ngOnInit() {
    this.statusselected = this.supervision.info.status;
    this.loading = false;
    let status=this.supervision.info.status;
    if (status==SupervisionStatusEnum.VALIDATED){
      this.statuslist=[{ id: SupervisionStatusEnum.TOVALIDATE, name: "Mark supervision for Re-Validation" }];
    }
    else if (status==SupervisionStatusEnum.TOVALIDATE || status==SupervisionStatusEnum.OPEN){
      this.statuslist=[{ id: SupervisionStatusEnum.VALIDATED, name: "Mark supervision as Validated" }];
    }
    else {
      this.statuslist=[{ id: SupervisionStatusEnum.VALIDATED, name: "Mark supervision as Validated" }];
    }        
  }


  ngAfterViewInit() {


  }

  public static openModal(dialog: MatDialog, supervision: Supervision): MatDialogRef<SupervStatusComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "600px";
    //dialogConfig.data = {entity2edit: entity2edit };

    let dialogRef: MatDialogRef<SupervStatusComponent>;
    dialogRef = dialog.open(SupervStatusComponent, dialogConfig);
    dialogRef.componentInstance.supervision = supervision;
    dialogRef.componentInstance.dialogRef=dialogRef;
    return dialogRef;
  }

  save(value?: any) {
    this.submitted = true;
    this.loading = true;
    this.alertmessage = null;
    try {

      let supervst = new Supervision();
      supervst.id = this.supervision.id;
      supervst.info.status = this.statusselected;
      if (this.statusselected==SupervisionStatusEnum.VALIDATED){
        supervst.info.validated=new Date();
      }
      supervst.info.reports=undefined;//IMPORTANT porque es inicializado en el objeto y borra los reports en el servidor si se envia.

      this.solarService.supervisionEditCreate(supervst)
        .subscribe((res) => this.savehandleresult(res), err => this.savehandleError(err)
        );
    } catch (error) {
      this.submitted = false;
      this.loading = false;
      this.showerror(error);
    }
  }

  savehandleresult(resultmodel: Supervision) {
    console.log("status saved", resultmodel);
    this.submitted = false;
    this.loading = false;
    this.showmessage('Status changed');
    this.supervision.info.status = resultmodel.info.status;
    this.supervision.info.validated=resultmodel.info.validated;
    this.statusChange.emit(this.supervision.info.status);
    this.dialogRef.close();
  }

  savehandleError<T>(err: any) {
    this.handleError(err);
  }

  handleError<T>(err: any) {
    this.submitted = false;
    this.loading = false;
    this.showerror("Error saving site. Message: " + err.message);
    console.error('An error occurred:', err.message);
  }

}
